export default function groupArrayPattern<T>(
  arr: T[],
  pattern: number[]
): any[][] {
  const result: any[][] = []
  let index = 0

  while (index < arr.length) {
    for (const size of pattern) {
      if (index < arr.length) {
        result.push(arr.slice(index, index + size))
        index += size
      } else {
        break
      }
    }
  }

  return result
}

/* 
// Example usage:
const inputArray = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'];
const pattern = [1, 2, 3]; // Pattern for grouping
const groupedArray = groupArray<string[]>(inputArray, pattern);
console.log(groupedArray);

*/
